<template>
  <router-link to="financial-area">
    <div
      class="w-100 rotation-hover flex h-14 cursor-pointer justify-between rounded-2xl bg-grey-wind-2 px-4 transition duration-200 ease-in-out hover:shadow-xl hover:transition md:w-3/4 lg:w-56"
    >
      <div class="flex items-center">
        <img
          src="@/assets/svg/dashboard/financial-area.svg"
          alt="Pie chart for my portfolio"
          class="w-7"
        />
        <div class="ml-1.5 text-sm font-bold text-grey-2">
          {{ $t('financial_area.self') }}
        </div>
      </div>
      <img src="@/assets/svg/arrows/right_grey_arrow.svg" alt="right" class="w-1.5" />
    </div>
  </router-link>
</template>

<script>
export default {
  setup() {},
}
</script>

<style scoped>
.rotation-hover:hover > div > img {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
